module.exports = __webpack_public_path__ + "static/video-globale-dgfip-eea7f35f094b99c0c502c89844086245.mp4";